import { Component, Input } from "@angular/core";
import { Breadcrumb } from "#models/utilities/breadcrumb.model";

@Component({
    selector: "app-breadcrumb",
    templateUrl: "./breadcrumb.component.html",
    styleUrls: ["./breadcrumb.component.scss"],
    standalone: false
})
export class BreadcrumbComponent {
  @Input()
  routes: Array<Breadcrumb>;

  @Input()
  routerArrow?: string[] | null = ['..'];
}
